/* Szállítási mód a kosárban (snippets/szallitasi-mod-valaszto.liquid vezérlője) — amnesia.hu-minta, 2026-09-06.
   Két sor: „Házhozszállítás" / „GLS csomagpont/box". A csomagpont-sor a GLS HIVATALOS térkép-webkomponensét nyitja
   (map.gls-hungary.com/widget/gls-dpm.js → <gls-dpm-dialog>, 'change' esemény: detail {id, name, type, contact{postalCode, city, address}, goldId…}).
   A választott pont kosár-attribútumba megy (/cart/update.js), a „Házhozszállítás" törli. A pénztárba a pont címe a kosár-form
   action-jében (/cart?checkout[shipping_address][…]) töltődik elő. App nem kell, nem-Plus bolton is megy. Globális + body-figyelő
   (a kosár-oldal AJAX-frissítése újrarendereli a blokkot — ezért a válasz után mindig a FRISS [data-szm] blokkot frissítjük). */
(function () {
  var GLS_SCRIPT = 'https://map.gls-hungary.com/widget/gls-dpm.js';
  var KULCS = { id: 'GLS_pont_id', nev: 'GLS_pont_nev', cim: 'GLS_pont_cim', tipus: 'GLS_pont_tipus', gold: 'GLS_pont_gold' };
  var dialog = null, scriptKerve = false, valasztottPont = null, mod = 'hazhoz';

  function glsScript() {
    if (window.customElements && customElements.get('gls-dpm-dialog')) return Promise.resolve();
    if (!scriptKerve) {
      scriptKerve = true;
      var s = document.createElement('script');
      s.type = 'module'; s.src = GLS_SCRIPT;
      document.head.appendChild(s);
    }
    return customElements.whenDefined('gls-dpm-dialog');
  }

  function attribFrissit(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (r) { return r.json(); });
  }

  // A mentett pont-cím („<irsz> <város>, <utca>") bontása — az oldal újratöltése után ebből megy a cím a pénztárba.
  // 2026-10-12 (K34): a szlovák és a cseh irányítószám szóközös („018 13", „120 00"); a régi minta csak az egybeírt
  // 4–5 jegyet ismerte, ezért ezeknél üres irányítószám és város ment a pénztárba. A magyar 4 jegyű alak változatlan.
  var PONT_CIM_MINTA = /^\s*(\d{3}\s?\d{2}|\d{4,5})\s+([^,]+?)\s*,\s*(.+)$/;

  function cimBont(cim) {
    var m = String(cim || '').match(PONT_CIM_MINTA);
    return m ? { irsz: m[1], varos: m[2], utca: m[3] } : { irsz: '', varos: '', utca: String(cim || '') };
  }

  // A látogató és a pénztár országa (kisbetűs ISO-kód). 2026-10-12 (K34): a választó blokkjából jön (data-szm-country =
  // a látogató Shopify-országa), tartalék a Shopify.country. Régen a pénztár a térkép-dialógusból vette, de az csak
  // abban az oldalbetöltésben létezik, amelyikben a térkép megnyílt: újratöltés után a pénztár HU-t kapott a szlovák
  // vagy cseh pont címével. Ha egyik forrás sem ad országot, üres.
  function valasztoOrszag(root) {
    var shopifyOrszag = window.Shopify && window.Shopify.country;
    var kod = (root && root.dataset.szmCountry) || shopifyOrszag || '';
    return String(kod).toLowerCase();
  }

  // A bolt saját országa (kisbetűs ISO-kód; a három témában boltonként más). 2026-10-12 (K31): a GLS-térkép mindig
  // ezt mutatja, és csomagpont csak ebbe az országba kérhető. Az SK-bolt piaca Csehországot is tartalmazza, de cseh
  // címre ott csak házhoz szállítás van: cseh pontot a cseh bolt kínál.
  var BOLT_ORSZAG = 'sk';

  // 2026-10-12 (K31): a látogató országát csak az SK-bolt nézi, mert csak az ő piacán van másik ország is (CZ).
  // A HU- és a CZ-bolt piaca egyországos: a pénztár eleve csak a bolt országába szállít, a szűrés ott nem véd
  // semmit. Arra viszont nincs mérés, hogy a Shopify a piacon kívüli (pl. külföldi IP-ről jövő) látogatónál a bolt
  // országát adja-e — ha nem, ott a csomagpont-sor eltűnne, és a vevő mentett pontja törlődne.
  var LATOGATO_ORSZAG_SZURES = true;

  // Ország híján a Liquid 'HU'-t ír (localization.country | default: 'HU'), így az SK-boltban az ismeretlen ország
  // is tiltást jelent. Üres ország csak akkor jön, ha sem a blokk, sem a Shopify.country nem ad értéket:
  // ott nem tiltunk.
  function pontValaszthato(root) {
    if (!LATOGATO_ORSZAG_SZURES) return true;
    var orszag = valasztoOrszag(root);
    return !orszag || orszag === BOLT_ORSZAG;
  }

  // 2026-10-12 (K32): a partner-automatákat a GLS válaszáig nem kínáljuk — nem tudjuk, kézbesít-e oda a GLS
  // külföldre, és szinte egyiken sincs utánvét. A kód a GLS pont-lista parcelLockerExternalProvider mezője
  // (2 = AlzaBox, 5 = DPD); a GLS saját automatái (CZ 1, HU 4, SK Balíkomat 3/4/8/9) maradnak.
  var KIZART_PARTNER_AUTOMATAK = { sk: '2', cz: '2,5' };

  function pontAdat(d) {
    var c = (d && d.contact) || {};
    var irsz = c.postalCode || c.zipCode || c.zip || '';
    var varos = c.city || '';
    var utca = c.address || d.address || '';
    var tipus = /locker|automata/i.test(String(d.type || '')) || /^GLS Automata/i.test(String(d.name || '')) ? 'automata' : 'csomagpont';
    return {
      id: String(d.id || ''), nev: String(d.name || ''),
      cim: (irsz + ' ' + varos + ', ' + utca).replace(/^\s+|\s+$/g, '').replace(/^,\s*/, ''),
      irsz: String(irsz), varos: String(varos), utca: String(utca), tipus: tipus,
      gold: String(d.goldId || d.externalId || '')
    };
  }

  function aktualisRoot() { return document.querySelector('[data-szm]'); }

  // 2026-10-12: a kosár-oldalon két választó van (a kosár-oldalsávé előrébb a DOM-ban, és a lapé). Állapotváltáskor
  // mindkettőt frissíteni kell, különben a látható lap-blokk a pont kiválasztása után is a házhoz-sort mutatja.
  function mindFrissit() { document.querySelectorAll('[data-szm]').forEach(uiFrissit); }

  // 2026-10-12 (K31): a rejtéshez inline stílus is kell, mert a téma .szm__sor szabálya (display: flex) felülírja
  // a böngésző [hidden] szabályát. Csak eltérésnél ír a DOM-ba, így a látható sor (HU, CZ, SK-látogató) érintetlen.
  function csomagpontSorLathato(csp, lathato) {
    if (csp.hidden === !lathato) return;
    csp.hidden = !lathato;
    csp.style.display = lathato ? '' : 'none';
  }

  // 2026-10-13 (K82): a szlovák és a cseh irányítószám kiírása szóközzel („811 06”) — csak a megjelenítés; a
  // mentett attribútum és a pénztárba menő cím változatlan (a cimBont mindkét alakot ismeri).
  function cimKiiras(cim) {
    return String(cim || '').replace(/^(\s*)(\d{3})(\d{2})(?=\s)/, '$1$2 $3');
  }

  function uiFrissit(root) {
    if (!root) return;
    var hazhoz = root.querySelector('[data-szm-mod="hazhoz"]');
    var csp = root.querySelector('[data-szm-mod="csomagpont"]');
    var blokk = root.querySelector('[data-szm-pont]');
    var hiba = root.querySelector('[data-szm-hiba]');
    var van = !!(valasztottPont && valasztottPont.id);
    if (van) mod = 'csomagpont';
    var cspAktiv = mod === 'csomagpont';
    root.dataset.szmPontId = van ? valasztottPont.id : '';
    hazhoz.classList.toggle('szm__sor--aktiv', !cspAktiv); hazhoz.setAttribute('aria-checked', String(!cspAktiv));
    csp.classList.toggle('szm__sor--aktiv', cspAktiv); csp.setAttribute('aria-checked', String(cspAktiv));
    csomagpontSorLathato(csp, pontValaszthato(root));
    if (van) {
      root.querySelector('[data-szm-pont-nev]').textContent = valasztottPont.nev;
      root.querySelector('[data-szm-pont-cim]').textContent = cimKiiras(valasztottPont.cim);
      blokk.hidden = false;
    } else blokk.hidden = true;
    if (hiba) hiba.hidden = true;
  }

  function pontMent(d) {
    var p = pontAdat(d);
    if (!p.id) return;
    var a = {}; a[KULCS.id] = p.id; a[KULCS.nev] = p.nev; a[KULCS.cim] = p.cim; a[KULCS.tipus] = p.tipus; a[KULCS.gold] = p.gold;
    valasztottPont = p; mod = 'csomagpont';
    mindFrissit();
    attribFrissit(a).then(function () { mindFrissit(); tetelTulajdonsag(jelolo(p)); }).catch(function () { mindFrissit(); });
  }

  // A pont öt kosár-attribútuma null értékkel: a /cart/update.js így törli őket.
  function pontNullAttributumok() {
    var a = {};
    Object.keys(KULCS).forEach(function (k) { a[KULCS[k]] = null; });
    return a;
  }

  function pontTorol() {
    var a = pontNullAttributumok();
    valasztottPont = null; mod = 'hazhoz';
    mindFrissit();
    attribFrissit(a).then(function () { mindFrissit(); tetelTulajdonsag(null); }).catch(function () { mindFrissit(); });
  }

  // 2026-10-12 (K31): idegen országú látogatónál a korábban mentett pont nem mehet a pénztárba: a címe a szállítási
  // címbe, a jelölője a rendelésre kerülne, és a TEXTICO pontos rendelésnek venné. Betöltéskor (oldalanként egyszer:
  // a kosár AJAX-frissítése a törlés beérkezéséig még a régi pontot rendereli) csak a kosár-attribútumot töröljük.
  // A tételek _gls_pont tulajdonsága a pénztár előtt kerül le, mert a /cart/change.js a mennyiséget is visszaírja, és
  // betöltés közben a vevő a +/- gombbal épp változtathat rajta.
  var IDEGEN_PENZTAR_VEDO_MS = 6000;   // lassú hálózat: ennyi után a pénztár akkor is nyílik, ha a tisztítás tart
  var idegenTisztitas = null;          // a futó vagy az utolsó tisztítás ígérete (Promise<boolean>)
  var idegenKosarTiszta = false;       // igazolva: a kosárban nincs pont-attribútum és _gls_pont
  var idegenPenztarFolyamatban = false;

  function vanPontAttributum(c) {
    var attr = c.attributes || {};
    return Object.keys(KULCS).some(function (k) { return !!attr[KULCS[k]]; });
  }

  function vanPontTetel(c) {
    return c.items.some(function (i) { return !!(i.properties || {})[PONT_TUL]; });
  }

  // Hibás válasz (pl. a Shopify JSON-hibaobjektuma) ne számítson tiszta kosárnak.
  function ervenyesKosar(c) {
    if (!c || !c.items) throw new Error('nem kosár-válasz');
    return c;
  }

  function kosarOlvas() {
    var opts = { credentials: 'same-origin', cache: 'no-store' };
    return fetch('/cart.js', opts).then(function (r) { return r.json(); }).then(ervenyesKosar);
  }

  // Leveszi a pont nyomait, és a kapott kosárból igazolja, hogy nem maradt. tetelekkel: a tételek _gls_pont
  // tulajdonságát is (csak a pénztár előtt). Eredmény: true = igazoltan tiszta; hibánál false, sosem dob.
  function idegenKosarTisztit(tetelekkel) {
    return kosarOlvas().then(function (c) {
      if (!vanPontAttributum(c)) return c;
      return attribFrissit(pontNullAttributumok()).then(ervenyesKosar);
    }).then(function (c) {
      if (!tetelekkel || !vanPontTetel(c)) return c;
      return tetelTulajdonsag(null).then(kosarOlvas);
    }).then(function (c) {
      idegenKosarTiszta = !vanPontAttributum(c) && !vanPontTetel(c);
      return idegenKosarTiszta;
    }).catch(function () {
      return false;
    });
  }

  function idegenPontTorles() {
    mod = 'hazhoz';
    if (idegenTisztitas) return;
    idegenTisztitas = idegenKosarTisztit(false);
  }

  // Pénztár idegen látogatónál: csak igazoltan tiszta kosárral megy tovább. A betöltéskori törlés lehet még úton
  // (megvárjuk), elbukhatott (újrapróba), a tételek jelölője pedig csak most kerül le. Utána a szokásos házhoz-út.
  // A vásárlást nem akasztjuk meg: hibánál vagy a védő idő után a pénztár így is nyílik (a ritka bent maradt pontot
  // ilyenkor a TEXTICO kézi kapuja fogja meg). A dupla kattintás nem indít második tisztítást.
  function idegenTisztitasMajdPenztar(form) {
    if (idegenPenztarFolyamatban) return;
    idegenPenztarFolyamatban = true;
    var kesz = false;
    function tovabb() {
      if (kesz) return;
      kesz = true;
      idegenPenztarFolyamatban = false;
      if (voltPontElotoltes()) ujKosarMajdPenztar(form, null);
      else location.assign('/checkout');
    }
    var vedo = setTimeout(tovabb, IDEGEN_PENZTAR_VEDO_MS);
    var elozo = idegenTisztitas || Promise.resolve(false);
    idegenTisztitas = elozo.then(function () { return idegenKosarTisztit(true); });
    idegenTisztitas.then(function () {
      clearTimeout(vedo);
      tovabb();
    });
  }

  function terkepNyit(root) {
    if (!pontValaszthato(root)) return;
    glsScript().then(function () {
      if (!dialog) {
        dialog = document.createElement('gls-dpm-dialog');
        dialog.setAttribute('country', BOLT_ORSZAG);
        if (KIZART_PARTNER_AUTOMATAK[BOLT_ORSZAG]) {
          dialog.setAttribute('exclude-external-providers', KIZART_PARTNER_AUTOMATAK[BOLT_ORSZAG]);
        }
        dialog.setAttribute('language', (root && root.dataset.szmLang) || 'hu');
        document.body.appendChild(dialog);
        dialog.addEventListener('change', function (e) {
          if (e && e.detail) pontMent(e.detail);
          try { dialog.close(); } catch (err) { /* nincs close */ }
        });
      }
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }).catch(function () {
      var r = aktualisRoot(); var hiba = r && r.querySelector('[data-szm-hiba]');
      if (hiba) hiba.hidden = false;
    });
  }

  // A pont-előtöltés JELE (localStorage): ha egyszer pont címével mentünk a pénztárba, a Shopify a kosár-tokenhez kötött pénztárban
  // ŐRZI a pont címét és az address2-jelölőt → a vevő házhozszállításra váltva a pont címét és díj-sorát kapta (2026-09-07 lelet).
  // Ezért házhoznál is friss tokennel, ÜRES címmel megyünk, ha a jel be van állítva; sikeres újraépítéskor a jel törlődik.
  var PONT_JEL = 'szm_pont_elotoltve';
  function pontJel(be) { try { if (be) localStorage.setItem(PONT_JEL, '1'); else localStorage.removeItem(PONT_JEL); } catch (err) { /* privát mód */ } }
  function voltPontElotoltes() { try { return localStorage.getItem(PONT_JEL) === '1'; } catch (err) { return false; } }

  // ÚJ KOSÁR-TOKEN a pontos pénztár előtt: a Shopify a pénztárban (kosár-tokenhez kötve) megjegyzi a korábban kijelölt szállítási módot,
  // így „pénztár → vissza → pont választása → pénztár" után a házhoz-sor maradna kijelölve. Friss kosárral a pénztár is friss: az első
  // sor (a pont díja) a kijelölt. Lépések: /cart.js → cart-süti lejáratása → /cart/add.js (tételek) → /cart/update.js (attribútumok,
  // megjegyzés) → a form beküldése a cím-előtöltéssel. Hiba esetén a régi kosárral megyünk tovább.
  // 2026-10-13 (user: „visszaugrott a főoldalra"): ha a csere a védő időn belül nem ér véget, vagy hibára fut, a régi
  // kosár sütije visszaáll, mielőtt a pénztár nyílik — különben a pénztár a félkész, ÜRES új kosárral nyílt, a Shopify a
  // főoldalra dobott, és a vevő kosara elveszett (mérve: a tételek visszatöltését 8 mp-re késleltetve). A süti értéke a
  // /cart.js tokenje URL-kódolva (mérve 2026-10-13, SK-bolt).
  var UJ_KOSAR_VEDO_MS = 6000;   // lassú hálózat: ennyi után a pénztár akkor is nyílik (a régi kosárral, ha a csere nem kész)
  function ujKosarMajdPenztar(form, p) {   // p = a pont (cím-előtöltés) VAGY null (házhoz: friss pénztár üres címmel)
    var fej = { 'Content-Type': 'application/json' }, opts = { credentials: 'same-origin', cache: 'no-store' };
    var cel = p ? '/checkout?' + cimParam(p) : '/checkout', kesz = false;
    var regiToken = null;     // a régi kosár tokenje, amíg a csere folyamatban van
    var csereKesz = false;    // a tételek ÉS az attribútumok igazoltan az új kosárban vannak
    if (p) pontJel(true);
    function regiKosarVissza() {
      if (!regiToken || csereKesz) return;
      document.cookie = 'cart=' + encodeURIComponent(regiToken) + '; path=/';
    }
    function tovabb() {   // GET: a Shopify a checkout[...] paramokból tölti a címet
      if (kesz) return;
      kesz = true;
      regiKosarVissza();
      location.assign(cel);
    }
    var vedo = setTimeout(tovabb, UJ_KOSAR_VEDO_MS);
    fetch('/cart.js', opts).then(function (r) { return r.json(); }).then(function (c) {
      if (kesz) return;   // a védő idő lejárt, a pénztár már nyílik: a régi kosárhoz nem nyúlunk
      var jel = p ? jelolo(p) : null;
      var items = (c.items || []).map(function (i) {
        var o = { id: i.variant_id, quantity: i.quantity };
        o.properties = {}; Object.keys(i.properties || {}).forEach(function (k) { if (k !== PONT_TUL) o.properties[k] = i.properties[k]; });
        if (jel) o.properties[PONT_TUL] = jel;   // az újraépített kosár minden tétele hordozza a pont jelölőjét
        if (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan) o.selling_plan = i.selling_plan_allocation.selling_plan.id;
        return o;
      });
      if (!items.length) return;
      var attrs = c.attributes || {}, note = c.note || '';
      regiToken = c.token;
      var lejar = '; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      document.cookie = 'cart=' + lejar;
      document.cookie = 'cart=' + lejar + '; domain=' + location.hostname;
      return fetch('/cart.js', opts).then(function (r) { return r.json(); }).then(function (c2) {
        // csak akkor építünk újra, ha a süti törlése tényleg ÚJ, ÜRES kosarat adott — különben a régi kosár marad (a
        // sütije visszaáll), és a tulajdonságot tételenként pótoljuk (nincs duplázás)
        if (!c2 || c2.token === regiToken || (c2.item_count || 0) > 0) {
          regiKosarVissza();
          regiToken = null;
          return tetelTulajdonsag(jel || null);
        }
        return fetch('/cart/add.js', { method: 'POST', headers: fej, credentials: 'same-origin', body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart/update.js', { method: 'POST', headers: fej, credentials: 'same-origin', body: JSON.stringify({ attributes: attrs, note: note }) }); })
          .then(function (r) {
            if (!r || !r.ok) throw new Error('update');
            if (kesz) return;   // a pénztár már a régi kosárral nyílt — az új kosár félre marad
            csereKesz = true;
            if (!p) pontJel(false);   // házhoz: a friss pénztár már nem hordozza a pont címét → a jel törölhető
          });
      });
    }).catch(function () { regiKosarVissza(); }).then(function () { clearTimeout(vedo); tovabb(); });
  }

  // A pont jelölője („Átvételi pont: <név> (<id>)"): a cím 2. sorába (vendég) ÉS a tételek rejtett _gls_pont tulajdonságába (bejelentkezett,
  // mentett címes vevőnél a Shopify a cím-előtöltést eldobja, a tétel-tulajdonságot viszont a díj-kérés mindig viszi) — a TEXTICO mindkettőből felismeri.
  var PONT_TUL = '_gls_pont';
  function jelolo(p) { return p && p.nev && p.id ? 'Výdajné miesto: ' + p.nev + ' (' + p.id + ')' : ''; }

  // A kosár minden tételére ráteszi (jel) vagy leveszi (null) a rejtett tulajdonságot — sorban, /cart/change.js-szel (a tétel kulcsa változik,
  // ezért mindig friss /cart.js-ből dolgozik). A vevő nem látja (aláhúzásos tulajdonság), az ár nem változik.
  function tetelTulajdonsag(jel) {
    var fej = { 'Content-Type': 'application/json' }, opts = { credentials: 'same-origin', cache: 'no-store' };
    function egy() {
      return fetch('/cart.js', opts).then(function (r) { return r.json(); }).then(function (c) {
        var t = (c.items || []).find(function (i) { var v = (i.properties || {})[PONT_TUL] || ''; return jel ? v !== jel : !!v; });
        if (!t) return;
        var props = {}; Object.keys(t.properties || {}).forEach(function (k) { if (k !== PONT_TUL) props[k] = t.properties[k]; });
        // Levételkor üres érték: a Shopify az üres properties-objektumot figyelmen kívül hagyja (a régi jelölő
        // maradna), az üres értékű kulcsot viszont törli (mérve 2026-10-13, éles HU-kosár).
        props[PONT_TUL] = jel || '';
        return fetch('/cart/change.js', { method: 'POST', headers: fej, credentials: 'same-origin', body: JSON.stringify({ id: t.key, quantity: t.quantity, properties: props }) })
          .then(function (r) { if (!r.ok) throw new Error('change'); return egy(); });
      });
    }
    return egy().catch(function () { /* a pénztár előtti újraépítés még pótolja */ });
  }

  // 2026-10-12 (K34): az ország minden oldalbetöltésben a választó blokkjából jön (valasztoOrszag). Ha nincs ország,
  // a paraméter kimarad (a pénztár a saját alapértelmezését használja) — így rossz, rögzített HU nem megy át.
  function cimParam(p) {
    var e = encodeURIComponent;
    var orszag = valasztoOrszag(aktualisRoot()).toUpperCase();
    var jel = jelolo(p);
    return 'checkout[shipping_address][address1]=' + e(p.utca) + '&checkout[shipping_address][city]=' + e(p.varos)
      + '&checkout[shipping_address][zip]=' + e(p.irsz)
      + (orszag ? '&checkout[shipping_address][country]=' + e(orszag) : '')
      + (jel ? '&checkout[shipping_address][address2]=' + e(jel) : '');
  }

  function bekot(root) {
    if (root.__szm) return;
    root.__szm = true;
    var valaszthato = pontValaszthato(root);
    if (!valaszthato) idegenPontTorles();
    // induló állapot a Liquid-ből (kosár-attribútumok)
    if (valaszthato && root.dataset.szmPontId && !valasztottPont) {
      var cim = (root.querySelector('[data-szm-pont-cim]') || {}).textContent || '';
      var b = cimBont(cim);
      valasztottPont = { id: root.dataset.szmPontId, nev: (root.querySelector('[data-szm-pont-nev]') || {}).textContent || '', cim: cim, irsz: b.irsz, varos: b.varos, utca: b.utca };
      mod = 'csomagpont';
    }
    uiFrissit(root);
    root.querySelector('[data-szm-mod="hazhoz"]').addEventListener('click', function () {
      if (valasztottPont) pontTorol(); else { mod = 'hazhoz'; mindFrissit(); }
    });
    root.querySelector('[data-szm-mod="csomagpont"]').addEventListener('click', function () {
      if (!pontValaszthato(root)) return;
      mod = 'csomagpont';
      mindFrissit();
      if (!valasztottPont) terkepNyit(root);
    });
    var modosit = root.querySelector('[data-szm-modosit]');
    if (modosit) modosit.addEventListener('click', function () { terkepNyit(root); });
    // Pénztár: csomagpont-sor pont nélkül → tilt + térkép; ponttal → a cím előtöltése a pénztárba (amnesia-minta)
    // a fiókban a doboz a formon KÍVÜL van, a Pénztár gomb form="CartDrawer-Form" → a data-szm-form mondja meg, melyik formot figyeljük
    // (a kosár-oldalon a fiók formja előrébb van a DOM-ban → a #cart form az elsődleges tartalék, csak utána az első /cart form)
    var form = (root.dataset.szmForm && document.getElementById(root.dataset.szmForm)) || root.closest('form')
      || (!root.closest('cart-drawer') && document.getElementById('cart'))
      || document.querySelector('form[action$="/cart"], form[action*="/cart?"]');
    if (form && !form.__szmSubmit) {
      form.__szmSubmit = true;
      form.addEventListener('submit', function (e) {
        var r = aktualisRoot(); if (!r) return;
        if (!pontValaszthato(r) && !idegenKosarTiszta) {
          e.preventDefault();
          idegenTisztitasMajdPenztar(form);
          return;
        }
        if (mod === 'csomagpont' && !valasztottPont) {
          e.preventDefault(); var hiba = r.querySelector('[data-szm-hiba]'); if (hiba) hiba.hidden = false; terkepNyit(r); return;
        }
        if (valasztottPont && valasztottPont.utca) { e.preventDefault(); ujKosarMajdPenztar(form, valasztottPont); return; }
        if (mod === 'hazhoz' && voltPontElotoltes()) { e.preventDefault(); ujKosarMajdPenztar(form, null); return; }   // korábbi pont-előtöltés → friss pénztár, üres címmel
        form.setAttribute('action', '/cart');
      });
    }
  }

  function mindBekot() { document.querySelectorAll('[data-szm]').forEach(bekot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mindBekot); else mindBekot();
  new MutationObserver(function () { mindBekot(); }).observe(document.body, { childList: true, subtree: true });
})();
